module.exports = __webpack_public_path__ + "media/assets/images/blog/man_at_work-small-dfc2366aa25a3f45711acab6dca394fe.jpeg";